<template>
	<div class="_font" style="display: flex;flex-direction: row;flex-wrap: nowrap;align-items: center;"
		:class="{_updown:true,widtfull:line,ITEMMEUTS:item['must']&&IsFormB}" v-if="VailShow(item)">
		<span class="_button" :style="{'width':line?'40%':'','visibility':item['type']!=7?'visible':'hidden',
			'display':checkbox||item['type']!=7?'block':'none','min-width':`${textMini}px`}">{{item['Display']}}
			<span style="color: red;margin-left: .1rem;font-weight: bold;" v-if="item['must']&&IsForm">*</span>
		</span>
		<template v-if="item['type']==2">
			<el-select v-model="form[item['name']]" :class="{widtfull:line}" :disabled="!!item['disabled']" @change="selectChange($event,item)" :clearable="!item['must']">
				<el-option v-for="(i,x) in item['dataSource']" :key="x" :value="i[item['valueName']]"
					:label="i[item['displayName']]">
					<template v-if="item['itemBoth']">
						<span style="float: left;margin-right: .8rem;">{{i[item['valueName']]}}</span>
						<span style="float: right; color: #8492a6;">{{(item['displayName2']?i[item['displayName2']]:i[item['displayName']])}}</span>
					</template>	
				</el-option>
			</el-select>
		</template>
		<template v-else-if="item['type']==3">
			<!-- 时间 -->
			<!-- <div v-if="item['dataType']!='日期'" :class="{widtfull:line}">
				<vxe-input v-model="form[`${item['name']}_From`]" placeholder="日期选择" type="date"></vxe-input>
				<span :class="{_updown:true}">——</span>
				<vxe-input v-model="form[`${item['name']}_To`]" placeholder="日期选择" type="date"></vxe-input>
			</div> -->
			<!-- <vxe-input v-model="form[`${item['name']}`]" placeholder="日期选择" type="date" :class="{widtfull:line}" v-else></vxe-input> -->
			<el-date-picker  :disabled="!!item['disabled']" v-model="form[`${item['name']}`]"  :value-format="item['dateTime']['format']" :class="{widtfull:line}" :type="item['dateTime']['type']" placeholder="日期选择" v-if="item['dateTime']">
			</el-date-picker>
			<el-date-picker :disabled="!!item['disabled']" v-model="form[`${item['name']}`]"  value-format="yyyy-MM-dd" :class="{widtfull:line}" type="date" placeholder="日期选择" v-else>
			</el-date-picker>
		</template>
		<template v-else-if="item['type']==4">
			<!-- 是否 -->
			<div :class="{widtfull:line}">
				<vxe-radio name="2" v-model="form[item['name']]"
					:label="form[item['name']]==undefined?undefined:''" content=""></vxe-radio>
				<vxe-radio name="1" v-model="form[item['name']]" label="True" content="是"></vxe-radio>
				<vxe-radio name="0" v-model="form[item['name']]" label="False" content="否"></vxe-radio>
			</div>
		</template>
		<template v-else-if="item['type']==7">
			<!-- checkbox -->
			<vxe-checkbox v-model="form[item['name']]" :content="item['Display']" :class="{widtfull:line}">
			</vxe-checkbox>
		</template>
		<template v-else-if="item['type']==8">
			<!-- 下拉容器表格 -->
			<dropTable :value="form[item['name']]" :class="{widtfull:line}" :tableData4="item['dataSource']"
				:tableColumn4="item['header']" :valuename="item['valueName']" @click="changeValue(item,$event)">
			</dropTable>
		</template>
		<template v-else>
			<template v-if="item['dataType']!=''">
				<div :class="{widtfull:line}" class="flex flex_row flex-nowrap ">
					<!-- 文本框 -->
					<vxe-input v-model="form[item['name']]" :placeholder="item['display']" :type="item['dataType']"
						:disabled="!!item['disabled']" clearable :class="{widtfull:line,_font:true,'is--cjjError':IsForm&&item['error']}" 
						@blur="$emit('blur',item)" :min="item['min']"></vxe-input>
					<slot :customerData="item" name="right"></slot>
				</div>
				
			</template>
			<template v-else>
				<div :class="{widtfull:line,_font:true}">
					{{form[item['name']]}}
				</div>
			</template>
		</template>
		<!-- <slot :customerData="item" name="bottom"></slot> -->
	</div>
</template>

<script>
	export default {
		name: 'CFilter',
		props: {
			item: {
				type: Object,
				default: () => {}
			},
			form: {
				type: Object,
				default: () => {}
			},
			wrap: {
				type: Boolean,
				default: false
			},
			line: {
				type: Boolean,
				default: false
			},
			VailShow: {
				type: Function,
				default: () =>{
					return true;
				}
			},
			checkbox: {
				type: Boolean,
				default: false
			},
			textMini: {
				type: Number,
				default: 0
			},
			IsForm:{
				type:Boolean,
				default:false
			},
			IsFormB:{
				type:Boolean,
				default:false
			}
		},
		methods: {
			checkErr(){
				let res=false;
				for(let i in this.dataSource){
					let name= this.dataSource[i]['name'];
					if(this.dataSource[i]['must']){
						if(!this.form[name]||String(this.form[name])==''){
							this.dataSource[i]['error']=true;
							res=true;
						}
					}
				}
				this.$forceUpdate();
				if(res)
					throw '';
			},
			changeValue(item, $event) {
				console.log($event)
				this.form[item['name']] = $event;
				this.$forceUpdate();
			},
			selectChange(e,filteritem){
				this.$emit('changeValue',{'$event':e,filteritem});
			}
		},
		computed: {
			VailShowFn(item) {
				let fn = (item) => this.VailShow(item);
				return fn;
			}
		}
	}
</script>

<style scoped>
	.eldatepick{
		height: 1.4rem;
	}
	
	.widtfull {
		width: 100% !important;
	}

	._updown {
		margin: 0 0 .2rem 0;
		white-space: nowrap;
	}

	._button {
		margin-right: .5rem;
		/* font-weight: 600; */
		font-size: .8rem;
	}

	._updown+._updown {
		margin-right: 5px;
	}

	.my-dropdown4 {
		/* width: 600px; */
		height: 10rem;
		background-color: #fff;
		box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.1);
	}
	.widtfull .el-input{
		font-size: .8rem;
	}
	._font{
		font-size: .8rem !important;
	}
</style>
